import { Route, Routes } from 'react-router-dom';
import './App.css';
import "./assets/css/general/Fontstyle.css";


import PageNotFound from './screens/general/PageNotFound';


import Aboutus from './screens/customer/aboutus/Aboutus';
import Blogs from './screens/customer/blogs/Blogs';
import Contact from './screens/customer/contact/Contact';
import MyReviews from './screens/customer/dashboard/myreviews/MyReviews';
import Profile from './screens/customer/dashboard/profile/Profile';
import Home from './screens/customer/home/Home';
import PrivacyPolicy from './screens/customer/privacyPolicy/PrivacyPolicy';
import Services from './screens/customer/services/Services';
import TermsConditions from './screens/customer/terms&conditions/TermsConditions';



import AppHome from './screens/customer/dashboard/apphome/AppHome';
import AllServices from './screens/customer/dashboard/appservices/AllServices';
import CustomerSettings from './screens/customer/dashboard/customersettings/CustomerSettings';
import MyJobs from './screens/customer/dashboard/myjobs/MyJobs';



import AdminMasterLayout from './Layouts/adminmasterlayout/AdminMasterLayout';
import AdminLogin from './screens/admin/auth/AdminLogin/AdminLogin';
import AdminCategories from './screens/admin/dashboard/admincategories/AdminCategories';
import AdminCustomer from './screens/admin/dashboard/admincustomer/AdminCustomer';
import Adminhome from './screens/admin/dashboard/Adminhome/Adminhome';
import AdminNotifications from './screens/admin/dashboard/adminnotification/AdminNotifications';
import AdminServices from './screens/admin/dashboard/Adminservices/AdminServices';
import AdminSetting from './screens/admin/dashboard/Adminsettings/AdminSetting';
import AdminBlogs from './screens/admin/dashboard/blogs/AdminBlogs';
import AdminBookings from './screens/admin/dashboard/booking/AdminBookings';
import AdminEarnings from './screens/admin/dashboard/earning/AdminEarnings';
import AdminFaq from './screens/admin/dashboard/faq/AdminFaqs';
import AdminKyc from './screens/admin/dashboard/adminkyc/AdminKyc';
import SubAdmins from './screens/admin/dashboard/subadmins/SubAdmins';
import SupportTickets from './screens/admin/dashboard/supporttickets/SupportTickets';
import SystemJobs from './screens/admin/dashboard/systemjobs/SystemJobs';


// import Subscription from './screens/admin/dashboard/subscriptions/Subscription';



// import Subscription from './screens/admin/dashboard/subscriptions/Subscription';

import AdminSubscription from './screens/admin/dashboard/subscriptions/AdminSubscription';





import WorkerNavbar from './components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import WorkerMasterLayout from './Layouts/workermasterlayout/WorkerMasterLayout';
import WorkerHome from './screens/serviceprovider/dashboard/workerhome/WorkerHome';
import WorkerDashboard from './screens/serviceprovider/dashboard/workerprofile/WorkerProfile';
// import WorkerSubscription from './screens/serviceprovider/dashboard/subscription/WorkerSubscription';

import BidJobs from './screens/serviceprovider/dashboard/bidjobs/BidJobs';
import WorkerBookingg from './screens/serviceprovider/dashboard/bookingg/WorkerBookingg';
import FAQ from './screens/serviceprovider/dashboard/faq/FAQ';
import HelpSupport from './screens/serviceprovider/dashboard/helpsupport/HelpSupport';
import KYC from './screens/serviceprovider/dashboard/kyc/KYC';
import MyEarnings from './screens/serviceprovider/dashboard/myearnings/MyEarnings';
import WorkerNotifications from './screens/serviceprovider/dashboard/notification/Nottification';
import Settings from './screens/serviceprovider/dashboard/settings/Settings';
import CustomerSubscription from './screens/customer/dashboard/subscription/CustomerSubscription';
import WorkerChat from './screens/serviceprovider/dashboard/workerchat/WorkerChat';

import BlogsDetail from './screens/customer/blogs/BlogsDetail';
import BookServices from './screens/customer/dashboard/appservices/BookServices';
import ServiceWorkers from './screens/customer/dashboard/appservices/ServiceWorkers';
import WorkerProfile from './screens/customer/dashboard/appservices/WorkerProfile';
import Favorites from './screens/customer/dashboard/favorites/Favorites';
import HelpAndSupport from './screens/customer/dashboard/helpsupport/HelpAndSupport';
import CustomerChat from './screens/customer/dashboard/inbox/CustomerChat';
import CustomerInbox from './screens/customer/dashboard/inbox/CustomerInbox';
import BookingDetail from './screens/customer/dashboard/myBookings/BookingDetail';
import MyBookings from './screens/customer/dashboard/myBookings/MyBookings';
import Notifications from './screens/customer/dashboard/notification/Notifications';
import PostAJob from './screens/customer/dashboard/postajob/PostAJob';
import PrivacySecurity from './screens/customer/dashboard/privacy&security/PrivacySecurity';
import EditProfile from './screens/customer/dashboard/profilesetting/EditProfile';
import Faq from './screens/customer/dashboard/faq/Faq';


import HireProfessionals from './screens/customer/dashboard/hireprofessionals/HireProfessionals';
import RateReviews from './screens/customer/dashboard/myBookings/RateReviews';



import ReportsAnalytics from './screens/admin/dashboard/reportsandanalytics/ReportsAnalytics';
import BidDetails from './screens/customer/dashboard/myBookings/BidDetails';
import CommonFaqs from './screens/customer/generalfaqs/CommonFaqs';
import ScrollToTop from './screens/general/scrolltotop/ScrollToTop';
import ReportedCustomers from './screens/admin/dashboard/reportedcustomers/Reportedcustomers';
import Subscription from './screens/general/subscription/Subscription';
import WorkerSubscriptionsPlan from './screens/serviceprovider/dashboard/subscription/WorkerSubscriptionsPlan';
import SubscriptionHistory from './screens/serviceprovider/dashboard/subscription/SubscriptionHistory';
import WorkerSubHistory from './screens/customer/dashboard/subscription/WorkerSubHistory';










function App() {
  return (
    <>

      <ScrollToTop />

      <Routes>
        {/* Landing routes */}
        {/* <Route path='/' element={<h1>} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<Services />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        {/* <Route path="/blogs/:slug" element={<BlogsDetail/>} /> */}
        <Route path="/blogs/:slug" element={<BlogsDetail />} />
        {/* services book now route */}
        {/* <Route path="/booknow/:workerId" element={<BookNow />} /> */}
        <Route path='/terms-conditions' element={<TermsConditions />} />
        <Route path='privacy-policy' element={<PrivacyPolicy />} />
        <Route path='faqs' element={<CommonFaqs />} />


        {/* <Route path="/customer-my-jobs" element={<MyJobs />}/> */}
        {/* <Route path='/' */}




        {/* AdminDashboard routes */}

        <Route path="/admin-home" element={<AdminMasterLayout><Adminhome /></AdminMasterLayout>} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-customer" element={<AdminMasterLayout><AdminCustomer /></AdminMasterLayout>} />
        <Route path="/admin-kyc" element={<AdminMasterLayout><AdminKyc /></AdminMasterLayout>} />
        <Route path="/admin-services" element={<AdminMasterLayout><AdminServices /></AdminMasterLayout>} />
        <Route path="/admin-categories" element={<AdminMasterLayout><AdminCategories /></AdminMasterLayout>} />
        <Route path="/admin-blogs" element={<AdminMasterLayout><AdminBlogs /></AdminMasterLayout>} />
        <Route path="/admin-booking" element={<AdminMasterLayout><AdminBookings /></AdminMasterLayout>} />
        <Route path="/admin-settings" element={<AdminMasterLayout><AdminSetting /></AdminMasterLayout>} />
        <Route path="/system-jobs" element={<AdminMasterLayout><SystemJobs /></AdminMasterLayout>} />
        {/* <Route path="/addblog" element={<AdminMasterLayout><AddBlog /></AdminMasterLayout>} /> */}
        <Route path="/admin-earnings" element={<AdminMasterLayout><AdminEarnings /></AdminMasterLayout>} />
        <Route path="/support-tickets" element={<AdminMasterLayout><SupportTickets /></AdminMasterLayout>} />
        {/* <Route path="/admin/blog/:slug" element={<AdminMasterLayout><BlogView /></AdminMasterLayout>} /> */}
        <Route path="/view-report" element={<AdminMasterLayout><ReportsAnalytics /></AdminMasterLayout>} />
        <Route path="/admin-notifications" element={<AdminMasterLayout><AdminNotifications /></AdminMasterLayout>} />
        <Route path="/admin-subadmins" element={<AdminMasterLayout><SubAdmins /></AdminMasterLayout>} />
        <Route path="/admin-faqs" element={<AdminMasterLayout><AdminFaq /></AdminMasterLayout>} />
        <Route path="/admin-reported-customers" element={<AdminMasterLayout><ReportedCustomers /></AdminMasterLayout>} />
        <Route path="/admin-subscriptions" element={<AdminMasterLayout><AdminSubscription /></AdminMasterLayout>} />







        {/* WorkerDashboard Routes */}

        <Route path="/worker-dashboard" element={<WorkerMasterLayout><WorkerHome /></WorkerMasterLayout>} />
        <Route path="/worker-navbar" element={<WorkerMasterLayout><WorkerNavbar /></WorkerMasterLayout>} />
        <Route path="/worker-profile" element={<WorkerMasterLayout><WorkerDashboard /></WorkerMasterLayout>} />
        <Route path="/worker-booking" element={<WorkerMasterLayout><WorkerBookingg /></WorkerMasterLayout>} />
        <Route path="/bid-jobs" element={<WorkerMasterLayout><BidJobs /></WorkerMasterLayout>} />
        <Route path="/worker-earnings" element={<WorkerMasterLayout><MyEarnings /></WorkerMasterLayout>} />
        {/* <Route path="/reviews-rating" element={<Reviews />} /> */}
        {/* <Route path="/my-profile" element={<MyProfile />} /> */}
        <Route path="/worker-settings" element={<WorkerMasterLayout><Settings /></WorkerMasterLayout>} />
        <Route path="/worker-notifications" element={<WorkerMasterLayout><WorkerNotifications /></WorkerMasterLayout>} />
        <Route path="/worker-faq" element={<WorkerMasterLayout><FAQ /></WorkerMasterLayout>} />
        <Route path="/worker-support" element={<WorkerMasterLayout><HelpSupport /></WorkerMasterLayout>} />
        <Route path="/worker-kyc" element={<WorkerMasterLayout><KYC /></WorkerMasterLayout>} />
        {/* <Route path="/worker-subscription" element={<WorkerMasterLayout><WorkerSubscription /></WorkerMasterLayout>} /> */}
        <Route path="/workersubscription" element={<WorkerMasterLayout><WorkerSubscriptionsPlan /></WorkerMasterLayout>} />
<Route path="/worker-chat/:conversationId" element={<WorkerMasterLayout><WorkerChat /></WorkerMasterLayout>} />        <Route   path="/worker-subscription-history" element={<WorkerMasterLayout><WorkerSubHistory /></WorkerMasterLayout>}/>






        {/* customer dashboard routed */}




        {/* <Route path="/customer-orders" element={<CustomerMasterLayout><MyOrders /></CustomerMasterLayout>} /> */}


        {/* <Route path="/customer-reviews" element={<CustomerMasterLayout><MyReviews /></CustomerMasterLayout>} /> */}



        {/* <Route path="//book-now/:id" element={<CustomerMasterLayout><BookNow /></CustomerMasterLayout>} /> */}
        {/* <Route path="/customer-profile" element={<CustomerMasterLayout><CustomerProfile /></CustomerMasterLayout>} /> */}






        {/* app view */}
        <Route path="/customer-dashboard" element={<AppHome />} />
        <Route path="/customer-subscription" element={<CustomerSubscription />} />
        <Route path="/customer-profile" element={<Profile />} />
        <Route path="/chat/:conversationId" element={<CustomerChat />} />
                <Route path="/chat" element={<CustomerChat />} />

        <Route path="/customer-inbox" element={<CustomerInbox />} />
        <Route path="/customer-category" element={<AllServices />} />
        <Route path="/book-service" element={<BookServices />} />
        <Route path="/book-workers" element={<WorkerProfile />} />
        <Route path="/professionals" element={<ServiceWorkers />} />
        <Route path="/post-a-job" element={<PostAJob />} />
        <Route path="/profile-settings" element={<EditProfile />} />
        <Route path="/mybookings" element={<MyBookings />} />
        <Route path="/booking-detail" element={<BookingDetail />} />
        <Route path="/customer-support" element={<HelpAndSupport />} />
        <Route path="/customer-reviews" element={<MyReviews />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/customer-notifications" element={<Notifications />} />
        <Route path="/privacy-security" element={<PrivacySecurity />} />
        <Route path="/customer-settings" element={<CustomerSettings />} />
        <Route path="/hire-professional" element={<HireProfessionals />} />
        <Route path="/rate-review/:id" element={<RateReviews />} />
        <Route path="/bid-details" element={<BidDetails />} />
        <Route path="/my-jobs" element={<MyJobs />} />
        <Route path="/customer-faq" element={<Faq />} />
<Route path="/subscription-history" element={<SubscriptionHistory />} />





        {/* <Route path="/not-found" element={<PageNotFound />} />  */}
        <Route path="*" element={<PageNotFound />} />
        <Route path="/subscription" element={<Subscription />} />
      </Routes>



    </>

  );
}

export default App;



